// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Core__List = require("@rescript/core/src/Core__List.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Utils__AttachmentUrl = require("./Utils__AttachmentUrl.bs.js");

function join(separator, lastSeparatorOpt, list) {
  var lastSeparator = lastSeparatorOpt !== undefined ? lastSeparatorOpt : separator;
  return Core__List.reduceWithIndex(list, "", (function (acc, x, i) {
                if (i !== 0) {
                  if (i === (Core__List.length(list) - 1 | 0)) {
                    return acc + (lastSeparator + x);
                  } else {
                    return acc + (separator + x);
                  }
                } else {
                  return x;
                }
              }));
}

function findFirst(predicate, _xs) {
  while(true) {
    var xs = _xs;
    if (!xs) {
      return ;
    }
    var hd = xs.hd;
    if (predicate(hd)) {
      return Caml_option.some(hd);
    }
    _xs = xs.tl;
    continue ;
  };
}

function pseudoJoin(joiner, lastJoiner, xs) {
  if (!xs) {
    return /* [] */0;
  }
  var tail = xs.tl;
  var hd = xs.hd;
  if (tail) {
    if (tail.tl) {
      return {
              hd: hd,
              tl: {
                hd: joiner,
                tl: pseudoJoin(joiner, lastJoiner, tail)
              }
            };
    } else {
      return {
              hd: hd,
              tl: {
                hd: Core__Option.getOr(lastJoiner, joiner),
                tl: {
                  hd: tail.hd,
                  tl: /* [] */0
                }
              }
            };
    }
  } else {
    return {
            hd: hd,
            tl: /* [] */0
          };
  }
}

function stripNones(x) {
  return Core__List.filterMap(x, (function (x) {
                return x;
              }));
}

var List = {
  join: join,
  findFirst: findFirst,
  pseudoJoin: pseudoJoin,
  stripNones: stripNones
};

function uniq(input, fn) {
  return Core__Array.reduce(input, [], (function (newArr, value) {
                if (newArr.some(function (a) {
                        return fn(a) === fn(value);
                      })) {
                  return newArr;
                } else {
                  return [value].concat(newArr);
                }
              }));
}

function pseudoJoin$1(joiner, lastJoiner, arr) {
  return Core__List.toArray((function (__x) {
                  return pseudoJoin(joiner, lastJoiner, __x);
                })(Core__List.fromArray(arr)));
}

function joinWith(joinStr, arr) {
  return arr.join(joinStr);
}

function joinWithLabels(separator, arr) {
  return arr.join(separator);
}

function sort(cmp, arr) {
  var cp = arr.slice();
  if (cmp !== undefined) {
    ((function (__x) {
            $$Array.sort(cmp, __x);
          })(cp));
  } else {
    ((function (__x) {
            $$Array.sort(Caml_obj.compare, __x);
          })(cp));
  }
  return cp;
}

function stripNones$1(x) {
  return Core__Array.filterMap(x, (function (x) {
                return x;
              }));
}

function join$1(separator, lastSeparatorOpt, list) {
  var lastSeparator = lastSeparatorOpt !== undefined ? lastSeparatorOpt : separator;
  return Core__Array.reduceWithIndex(list, "", (function (acc, x, i) {
                if (i !== 0) {
                  if (i === (list.length - 1 | 0)) {
                    return acc + (lastSeparator + x);
                  } else {
                    return acc + (separator + x);
                  }
                } else {
                  return x;
                }
              }));
}

var $$Array$1 = {
  uniq: uniq,
  pseudoJoin: pseudoJoin$1,
  joinWith: joinWith,
  joinWithLabels: joinWithLabels,
  sort: sort,
  stripNones: stripNones$1,
  join: join$1
};

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.substring(1);
}

var nbsp = '\u00a0';

var upperHalfBlock = '\u2580';

var lowerHalfBlock = '\u2584';

var lastCommaRe = /,(?!.*,)/gmi;

function enumerate(strings) {
  return Core__List.toArray(strings).join(", ").replace(lastCommaRe, " and");
}

function formatAsPhone(value) {
  var value$1 = value.replace(/\D/g, "");
  if (value$1.length === 0) {
    return "";
  }
  var first = value$1.substring(0, 3);
  var middle = value$1.substring(3, 6);
  var last = value$1.substring(6, 10);
  if (value$1.length > 6) {
    return "(" + first + ") " + middle + " - " + last;
  } else if (value$1.length > 3) {
    return "(" + first + ") " + middle;
  } else {
    return "(" + first;
  }
}

var $$String = {
  capitalize: capitalize,
  nbsp: nbsp,
  upperHalfBlock: upperHalfBlock,
  lowerHalfBlock: lowerHalfBlock,
  lastCommaRe: lastCommaRe,
  enumerate: enumerate,
  formatAsPhone: formatAsPhone
};

function ofOption(error, opt) {
  if (opt !== undefined) {
    return {
            TAG: "Ok",
            _0: Caml_option.valFromOption(opt)
          };
  } else {
    return {
            TAG: "Error",
            _0: error
          };
  }
}

var Result = {
  ofOption: ofOption
};

var UUID = {};

var Float = {};

function setCurrentRef(reactRef, value) {
  reactRef.current = value;
}

var React = {
  setCurrentRef: setCurrentRef
};

var makeAttachmentUrl = Utils__AttachmentUrl.makeAttachmentUrl;

var baseAttachmentUrl = Utils__AttachmentUrl.baseAttachmentUrl;

var $$Promise;

var Regex;

exports.makeAttachmentUrl = makeAttachmentUrl;
exports.baseAttachmentUrl = baseAttachmentUrl;
exports.List = List;
exports.$$Array = $$Array$1;
exports.$$String = $$String;
exports.Result = Result;
exports.UUID = UUID;
exports.Float = Float;
exports.React = React;
exports.$$Promise = $$Promise;
exports.Regex = Regex;
/* Utils__AttachmentUrl Not a pure module */
